var _defs, _rect, _rect2, _path, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTempLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 96,
    viewBox: "0 0 320 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0E97FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6CD4FF"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 316,
    height: 92,
    rx: 18,
    fill: "rgba(6,20,45,0.78)",
    stroke: "rgba(255,255,255,0.28)",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 22,
    width: 52,
    height: 52,
    rx: 12,
    fill: "url(#g1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 38H57V44H35V38ZM35 50H52V56H35V50Z",
    fill: "#FFFFFF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 46,
    fill: "#FFFFFF",
    fontSize: 22,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700
  }, "IT TECH")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 67,
    fill: "#9DDFFF",
    fontSize: 15,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 600
  }, "EUROPEAN")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempLogo);
export default __webpack_public_path__ + "static/media/temp-logo.53d4acfdf7facb647a4135904610f508.svg";
export { ForwardRef as ReactComponent };